<script lang="ts">
    import { initialMachineDEA } from "../state/machine";
    import AutomatonPane from "./dea/AutomatonPane.svelte";
    import {EditMode} from './dea/AutomatonPane.svelte';

    type EditModeType = typeof EditMode[keyof typeof EditMode];

    let editMode: EditModeType = EditMode.addNode;

    let machine = initialMachineDEA;
</script>

<div>
    <AutomatonPane machine={machine} />
</div>